import React, { useContext, useEffect, useRef, useState } from 'react';
import './PurchaseInvoice.css';
import { useParams } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { formatedDate } from '../../Helper/constent';
import PurchasePrint from '../PrintHelper/PurchasePrint';

const PurchaseInvoice = () => {
    const { purchase_id, stock_status } = useParams();
    const toast = useRef(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [invoiceData, setInvoiceData] = useState({});
    const [products, setProducts] = useState([]);
    const [user, setUser] = useState({});
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const headers = apiHeadersJson;

    const handlePrint = () => {
        const htmlContent = `
      <html>
        <body>
          <h1>Hello, Print This Silently!</h1>
        </body>
      </html>
    `;
        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            window.print();
        }
    };

    const GetList = async () => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetPurchaseInvoice`, { params: { purchase_id, stock_status }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data);
                setProducts(prodcuts);
                setUser(user[0]);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
        } finally {
            setDataLoading(false);
        }
    };

    useEffect(() => {
        GetList();
    }, []);

    if (dataLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>

        )
    }
    const purchaseDetails = invoiceData[0];

    return (
        <>
            <PurchasePrint purchaseDetails={purchaseDetails} products={products} user={user} isShow={true} />
            <button onClick={handlePrint} className="puechase-print-button">Print</button>
        </>
    );

};

export default PurchaseInvoice;
